// frontend / src / slices / authSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

const initialState = {
  userInfo: localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null,
  permissions: localStorage.getItem('permissions')
    ? JSON.parse(localStorage.getItem('permissions'))
    : null,
  date1mem: DateTime.local().minus({ days: 7 }).toISO(),
  date2mem: DateTime.local().toISO(),
  lastDrawerFetch: null, // ISO string, напр. '2026-01-15T22:00:00.000Z'
  tempReportSettings: localStorage.getItem('tempReportSettings')
    ? JSON.parse(localStorage.getItem('tempReportSettings'))
    : null,
  selectedSettings: null,
  sections: [],
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAppAccess: (state, action) => {
      // Переименовали setMenuData
      if (action.payload.permissions) {
        state.permissions = action.payload.permissions;
      }
      if (action.payload.sections) {
        state.sections = action.payload.sections;
      }
    },
    setDrawerFetchTime: (state) => {
      state.lastDrawerFetch = DateTime.local().toISO(); // luxon ISO
    },
    setCredentials: (state, action) => {
      state.userInfo = action.payload;
      localStorage.setItem('userInfo', JSON.stringify(action.payload));
    },
    logout: (state, action) => {
      state.userInfo = null;
      state.lastDrawerFetch = null;
      localStorage.removeItem('userInfo');
    },
    setDate1mem: (state, action) => {
      state.date1mem = action.payload;
    },
    setDate2mem: (state, action) => {
      state.date2mem = action.payload;
    },
    setPermissions: (state, action) => {
      state.permissions = action.payload;
    },
    setTempReportSettings: (state, action) => {
      const { code, settings } = action.payload;
      if (code) {
        const data = { ...state.tempReportSettings, [code]: settings };
        state.tempReportSettings = data;
        localStorage.setItem('tempReportSettings', JSON.stringify(data));
      }
    },
    setSelectedSettings: (state, action) => {
      const { code, settings } = action.payload;
      if (code) {
        state.selectedSettings = {
          ...state.selectedSettings,
          [code]: settings,
        };
      }
    },
  },
});

export const {
  setAppAccess,
  setSelectedSettings,
  setTempReportSettings,
  setPermissions,
  setDrawerFetchTime,
  setCredentials,
  logout,
  setDate1mem,
  setDate2mem,
} = authSlice.actions;
export default authSlice.reducer;
